import { I18n, User, I18nType, UserType } from '@schemas'

class AccessGroup {
	constructor({
		id = '',
		name = '',
		i18n = [],
		users = [],
		createdBy = '',
		createdAt = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.name = name === null ? '' : name
		this.i18n = i18n === null ? [] : (i18n.map(anI18n => new I18n(anI18n)) as I18nType[])
		this.users = users === null ? [] : (users.map(aUser => new User(aUser)) as UserType[])
		this.createdBy = createdBy === null ? '' : createdBy
		this.createdAt = createdAt === null ? '' : createdAt
	}
	id: string
	name: string
	i18n: I18nType[]
	users: UserType[]
	createdBy: string
	createdAt: string
}

export { AccessGroup }
